

export const TYPE_INPUT = {
  FILE: '1',
  FILE_CAMERA: '2'
};

export const TYPE_FILE = {
  BOOKING: '5',
  IE: '6'
};

export const TYPE_OPERACION = {
  MARITIMO: '1',
  MARITIMO_TEXT: 'MARÍTIMO',
  TERRESTRE: '2',
  TERRESTRE_TEXT: 'TERRESTRE',
  AEREO: '3',
  AEREO_TEXT: 'AÉREO',
};

export const TYPE_USER = {
  ADMINISTRADOR: '1',
  OPERACIONES: '2',
  DOCUMENTACION: '3',
};



